
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  DeleteSponsorApi,
  FetchSponsorProducts,
} from "../../ApiCalls/AddProducts";
import { BASE_URL } from "../../constant/api";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import { toast, ToastContainer } from "react-toastify";

const SellerSponsorView = () => {
  const { sponsorId } = useParams();
  const [sponsor, setSponsor] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedSponsor, setSelectedSponsor] = useState(null); // For delete confirmation
  const navigate = useNavigate();
  useEffect(() => {
    const fetchSponsor = async () => {
      setLoading(true);
      try {
        const response = await FetchSponsorProducts(sponsorId);
        setSponsor(response);
        setError(null);
      } catch (err) {
        console.error("Error fetching sponsor details:", err);
        setError("Failed to load sponsor details. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchSponsor();
  }, [sponsorId]);
  // Handle delete confirmation
  const handleDelete = async () => {
    if (selectedSponsor) {
      try {
        console.log(selectedSponsor);

        await DeleteSponsorApi(selectedSponsor.sponsored.id);
        setShowConfirm(false);
        setSelectedSponsor(null);
        toast.success("Sponsor Deleted successfully!");
        navigate("/seller/offer_brand/sponsored");
        
      } catch (error) {
        console.error("Error deleting product:", error.message || error);
        setShowConfirm(false);
        toast.error("Error deleting Sponsor!");
      }
    }
  };
  return (
    <div>
      <ToastContainer position="top-center" autoClose={3000} />

      <div className="container mx-auto px-4 py-6">
        {loading ? (
          <div className="text-center">
            <div className="spinner-border inline-block h-8 w-8 animate-spin rounded-full border-4 text-brand-primary"></div>
            <p className="mt-2 text-gray-600">Loading sponsor details...</p>
          </div>
        ) : error ? (
          <div className="text-center text-red-500">
            <p>{error}</p>
          </div>
        ) : sponsor ? (
          <div>
            <div className="mb-6 flex w-full gap-10">
              {/* Banner Display */}
              <div className="h-44 w-1/2 overflow-hidden rounded-lg bg-slate-100 shadow-md">
                {sponsor?.sponsored.sponsored_banner ? (
                  <img
                    src={
                      sponsor.sponsored.sponsored_banner.startsWith("http")
                        ? sponsor.sponsored_banner
                        : `${BASE_URL}${sponsor.sponsored.sponsored_banner}`
                    }
                    alt="Sponsor Banner"
                    className="h-full w-full object-cover"
                  />
                ) : (
                  <div className="flex h-full items-center justify-center bg-gray-200 font-medium text-gray-500">
                    No Banner Available
                  </div>
                )}
              </div>

              <div className="flex flex-1 flex-col space-y-4">
                <div className="flex w-1/3 flex-col space-y-1">
                  <label className="text-base font-medium text-brand-primary">
                    Title
                  </label>
                  <p className="rounded-lg border border-black p-2">
                    {sponsor.sponsored.title}
                  </p>
                </div>

                <div className="flex gap-4">
                  <div className="flex flex-col space-y-1">
                    <label className="text-base font-medium text-brand-primary">
                      Start Date
                    </label>
                    <p className="rounded-lg border border-black p-2">
                      {sponsor.sponsored.start_date}
                    </p>
                  </div>

                  <div className="flex flex-col space-y-1">
                    <label className="text-base font-medium text-brand-primary">
                      End Date
                    </label>
                    <p className="rounded-lg border border-black p-2">
                      {sponsor.sponsored.end_date}
                    </p>
                  </div>
                  <div className="mt-8 flex gap-4">
                    <Link
                      to={`/seller/offer_brand/sponsor/Edit/${sponsor.sponsored.id}`}
                    >
                      <div className="flex w-28 flex-1 items-center justify-center rounded-lg border border-blue-600 px-2 py-2 text-center text-xs font-medium text-blue-600 shadow-md transition hover:border-blue-700 hover:bg-blue-700 hover:text-white sm:text-sm">
                        Edit
                      </div>
                    </Link>

                    <div
                      onClick={() => {
                        setSelectedSponsor(sponsor);
                        setShowConfirm(true);
                      }}
                      className="flex w-28 flex-1 items-center justify-center rounded-lg border border-red-600 px-2 py-2 text-center text-xs font-medium text-red-600 shadow-md transition hover:border-red-700 hover:bg-red-700 hover:text-white sm:text-sm"
                    >
                      Delete
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Sponsored Products Table */}
            <div>
              <div className="grid grid-cols-[4rem,2fr,2.5fr,1.5fr,1.5fr,1fr] p-2 font-medium text-brand-button-green-bg">
                <div className="text-center">Item No</div>
                <div className="text-center">Product Code</div>
                <div className="text-center">Product Name</div>
                <div className="text-center">Stock</div>
                <div className="text-center">Price</div>
              </div>
              {sponsor.products && sponsor.products.length > 0 ? (
                sponsor.products.map((product, index) => (
                  <div
                    key={product.id}
                    className="grid grid-cols-[4rem,2fr,2.5fr,1.5fr,1.5fr,1fr] items-center gap-2 p-2 text-gray-700"
                  >
                    <div className="rounded-xl border p-2 text-center">
                      {index + 1}
                    </div>
                    <div className="rounded-xl border p-2 text-center">
                      {product.product_code}
                    </div>
                    <div className="rounded-xl border p-2 text-center">
                      {product.product_name}
                    </div>
                    <div className="rounded-xl border p-2 text-center">
                      {product.stock}
                    </div>
                    <div className="rounded-xl border p-2 text-center">
                      {product.price}
                    </div>
                    <Link to={`/seller/products/view/${product.id}`}>
                      <div className="flex flex-1 items-center justify-center rounded-lg border border-green-600 py-2 text-center text-xs font-medium text-green-600 shadow-md transition hover:border-green-700 hover:bg-green-700 hover:text-white sm:text-sm">
                        View
                      </div>
                    </Link>
                  </div>
                ))
              ) : (
                <div className="py-4 text-center text-gray-500">
                  No products sponsored yet
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="text-center text-gray-600">
            <p>No sponsor details found.</p>
          </div>
        )}
        {/* Delete Confirmation Modal */}
        {showConfirm && (
          <DeleteModal
            entityName="Sponsor"
            title={selectedSponsor.sponsored.title}
            onConfirm={handleDelete}
            onCancel={() => setShowConfirm(false)}
          />
        )}
      </div>
    </div>
  );
};

export default SellerSponsorView;
